
const LOGIN = 'login';
const LOGOUT = 'logout';
import Cookies from 'js-cookie'
let state={
  userId: '',
  token: null,
  deptCode:'',//部门代码统一为根公司代码
  deptId:'',//部门id
  areaCode:''
};
let mutations= {
  LOGIN(state, data){
    // Cookies.set('token', data.token, { expires: 1 });
    Cookies.set('username', data.user.name, { expires: 1 });
    Cookies.set('accountName', data.user.accountName, { expires: 1 });
    Cookies.set('userId', data.user.id, { expires: 1 });
    Cookies.set('name', data.user.name, { expires: 1 });
    if(data.user.provincecode) {
      Cookies.set('provincecode', data.user.provincecode, {expires: 1});
      Cookies.set('userId', data.user.userId, { expires: 1 });
    }else{
      Cookies.remove('provincecode');
    }
    if(data.user.citycode) {
      Cookies.set('citycode', data.user.citycode, {expires: 1});
    }else{
      Cookies.remove('citycode');
    }
    if(data.user.countycode) {
      Cookies.set('countycode', data.user.countycode, {expires: 1});
    }else{
      Cookies.remove('countycode');
    }
    if(data.user.townshipcode) {
      Cookies.set('townshipcode', data.user.townshipcode, {expires: 1});
    }else{
      Cookies.remove('townshipcode');
    }
    // Cookies.set('curAreaCode', data.user.qhdm, { expires: 1 });
    // Cookies.set('curAreaName', data.user.qhmc, { expires: 1 });
    Cookies.set('curAreaCode', data.user.qhdm, { expires: 1 });
    Cookies.set('curAreaName', data.user.qhmc, { expires: 1 });
    Cookies.set('appName', data.application.appName, { expires: 1 });
    Cookies.set('areacode', data.user.qhdm, { expires: 1 });
    Cookies.set('areaname', data.user.qhmc, { expires: 1 });

    Cookies.set('role',data.role,{ expires:1 });

    if(data.menuVoList){
      localStorage.setItem("menus", JSON.stringify(data.menuVoList || []));
    }
    if(data.perms){
      localStorage.setItem("perms", JSON.stringify(data.perms || []));
    }
    if(data.tasks){
      localStorage.setItem("tasks", JSON.stringify(data.tasks || []));
    }
    state.token = data.token;

  },
  LOGOUT(state){
    Cookies.remove('token');
    Cookies.remove('username');
    Cookies.remove('name');
    Cookies.remove('areacode');
    Cookies.remove('areaname');
    Cookies.remove('role');
    localStorage.removeItem('areaOptions');//当前用户乡级以上区域信息
    localStorage.removeItem("menus");
    localStorage.removeItem("perms");
    localStorage.removeItem("tasks");
    state.token = null
  }
}
export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/user.js